import React, { useState, useEffect } from 'react';
import { FiUser } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { Container, Nav, Navbar, NavDropdown, Offcanvas, Button, Form, Modal } from 'react-bootstrap';
import { api } from '../../apis/api';
import './header.css';
import logo from './../../asstes/admin-logo.png';
import brandLogo from './../../asstes/logo.png';

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export const Header = () => {
  const [show, setShow] = useState(false);
  const [loginShow, setLoginShow] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.getCategories();
        if (!cancelled) setCategories(res.data || []);
      } catch (_) {
        if (!cancelled) setCategories([]);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (email === 'smartcrackers3a@gmail.com' && password === 'smartcrackers3a@184') {
      setLoginShow(false);
      navigate('/admin');
    } else {
      setError('Invalid email or password.');
    }
  };

  const goHome = (e) => {
    e.preventDefault();
    setShow(false);
    window.dispatchEvent(new CustomEvent('navigateMainSite'));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goSection = (id) => (e) => {
    e.preventDefault();
    setShow(false);
    window.dispatchEvent(new CustomEvent('navigateMainSite'));
    scrollToId(id);
  };

  const goCategory = (categoryName) => (e) => {
    e.preventDefault();
    setShow(false);
    window.dispatchEvent(new CustomEvent('navigateMainSite'));
    window.dispatchEvent(new CustomEvent('selectCategory', { detail: categoryName }));
    scrollToId('products');
  };

  const categoryItems = categories.length === 0 ? (
    <NavDropdown.Item disabled>No categories</NavDropdown.Item>
  ) : (
    categories.map((cat) => (
      <NavDropdown.Item
        key={cat.category_id}
        href="#products"
        className="header__category-item"
        onClick={goCategory(cat.category_name)}
      >
        {cat.category_name}
      </NavDropdown.Item>
    ))
  );

  return (
    <div className="header__wrapper">
      {/* Marquee top bar */}
      <div className="header__marquee-bar">
        <marquee behavior="scroll" direction="left" scrollamount="6">
          🎆 Diwali Sale — Up to 80% Off! &nbsp;|&nbsp; 🧨 Premium Sparklers Now in Stock &nbsp;|&nbsp; 🎉 New Year Combo Packs Available &nbsp;|&nbsp; 🪔 Celebrate Every Moment with SmartCrackers &nbsp;|&nbsp; 🎆 Bulk Orders Welcome — Call Us Today! &nbsp;|&nbsp; 🎇 100% Safe & Licensed Products &nbsp;|&nbsp; 🧨 Shop the Best Crackers at Unbeatable Prices!
        </marquee>
      </div>

      {/* Navbar */}
      <Navbar expand="lg" className="header-nav" variant="dark">
        <Container fluid className="px-4">

          {/* Logo */}
          <a href="#home" onClick={goHome} aria-label="Home">
            <img className="logo" src={logo} alt="3A Smartcrackers" />
          </a>

          {/* Mobile toggle */}
          <Navbar.Toggle
            aria-controls="offcanvas-nav"
            onClick={() => setShow(true)}
            className="header__toggle"
          />

          {/* Desktop nav */}
          <Navbar.Collapse id="desktop-nav" className="d-none d-lg-flex">
            <Nav className="me-auto header__nav-menus">
              <Nav.Link href="#home" className="header__nav-link" onClick={goHome}>
                Home
              </Nav.Link>

              <NavDropdown
                title="Categories"
                className="header__nav-link header__categories-dropdown"
                renderMenuOnMount
              >
                {categoryItems}
              </NavDropdown>

              <Nav.Link href="#products" className="header__nav-link" onClick={goSection('products')}>
                Products
              </Nav.Link>

              <Nav.Link href="#about" className="header__nav-link" onClick={goSection('about')}>
                About Us
              </Nav.Link>
            </Nav>

            <div className="header__actions">
              <Button
                className="header__btn header__btn--primary"
                onClick={goSection('footer')}
              >
                Contact Us
              </Button>
              <button className="header__user-icon-btn" onClick={() => setLoginShow(true)} aria-label="Login">
                <FiUser size={20} color="#fff" />
              </button>
            </div>
          </Navbar.Collapse>

        </Container>
      </Navbar>

      {/* Mobile Offcanvas */}
      <Offcanvas show={show} onHide={() => setShow(false)} placement="start" className="header__offcanvas">
        <Offcanvas.Header closeButton closeVariant="white">
          <Offcanvas.Title className="header__logo">SmartCrackers</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form className="mb-3">
            <Form.Control
              type="search"
              placeholder="Search for crackers..."
              className="header__mobile-search"
            />
          </Form>

          <Nav className="flex-column">
            <Nav.Link href="#home" className="header__mobile-link" onClick={goHome}>
              Home
            </Nav.Link>

            <NavDropdown title="Categories" className="header__mobile-link header__categories-dropdown--mobile">
              {categories.length === 0 ? (
                <NavDropdown.Item disabled className="header__mobile-dropdown-item">No categories</NavDropdown.Item>
              ) : (
                categories.map((cat) => (
                  <NavDropdown.Item
                    key={cat.category_id}
                    href="#products"
                    className="header__mobile-dropdown-item"
                    onClick={goCategory(cat.category_name)}
                  >
                    {cat.category_name}
                  </NavDropdown.Item>
                ))
              )}
            </NavDropdown>

            <Nav.Link href="#products" className="header__mobile-link" onClick={goSection('products')}>
              Products
            </Nav.Link>

            <Nav.Link href="#about" className="header__mobile-link" onClick={goSection('about')}>
              About Us
            </Nav.Link>
          </Nav>

          <div className="mt-4">
            <Button className="header__btn header__btn--primary w-100" onClick={goSection('footer')}>
              Contact Us
            </Button>
          </div>
          <div className="mt-3 text-center">
            <button className="header__user-icon-btn" onClick={() => setLoginShow(true)} aria-label="Login">
              <FiUser size={22} color="#fff" />
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Login Modal */}
      <Modal show={loginShow} onHide={() => { setLoginShow(false); setError(''); }} centered className="header__login-modal">
        <button
          type="button"
          className="header__login-close"
          aria-label="Close"
          onClick={() => { setLoginShow(false); setError(''); }}
        >
          ×
        </button>
        <Modal.Body>
          <div className="header__login-brand">
            <img src={brandLogo} alt="3A Smartcrackers" className="header__login-logo" />
            <h2 className="header__login-title">Welcome back</h2>
            <p className="header__login-subtitle">Sign in to continue to your account</p>
          </div>
          <Form onSubmit={handleLogin} className="header__login-form">
            <Form.Group className="mb-3" controlId="loginEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-4" controlId="loginPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} />
            </Form.Group>
            {error && <p className="header__login-error">{error}</p>}
            <Button className="header__btn header__btn--primary header__login-submit w-100" type="submit">
              Sign in
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

    </div>
  );
};
